import React, { Component } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Redirect } from "react-router";
import { Alert, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import "../../static/style/dashboard.css";
import Button from "../../components/Button";
import { fetchPlan, createPlan } from "../../actions/index";
import moment from "moment/moment";

class PlanDeal extends Component {
  constructor(props, context) {
    super(props, context);

    this.getRow = this.getRow.bind(this);
    this.toggleChange = this.toggleChange.bind(this);
    this.confirmPlan = this.confirmPlan.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.toggle = this.toggle.bind(this);

    this.state = {
      redirect: false,
      isChecked: false,
      errorMsq: "",
      errorClass: "",
      visible: false,
      toDash: false,
      modal: false
    };
  }

  toggleChange() {
    this.setState({
      isChecked: !this.state.isChecked,
      errorClass: "text-success",
      visible: false
    });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  confirmPlan() {
    if (!this.state.isChecked) {
      this.setState({
        errorClass: "text-danger",
        visible: true
      });
    } else {
      this.setState({
        errorClass: "text-success",
        btnState: "",
        visible: false,
        toDash: false
      });
      const plan = this.props.plan.plan;

      this.props.createPlan(
        this.state.debt.id,
        Object.keys(plan.maksusopimusera_erittely).length,
        this.props.due
      );
      // this.props.history.push("/dashboard");
    }
  }

  onDismiss() {
    this.setState({ visible: !this.state.visible });
  }

  componentDidMount() {
    let redirect = false;

    if (!this.props.debts) {
      redirect = true;
    }

    if (!redirect) {
      const iid = this.props.match.params.id;
      let debt = null;

      for (var find of this.props.debts) {
        if (Number(find.id) === Number(iid)) {
          debt = find;
          break;
        }
      }

      if (debt) {
        this.setState({
          debt: debt
        });
      } else {
        redirect = true;
      }

      this.setState({
        plan: this.props.plan.plan
      });
    }

    this.setState({
      redirect: redirect
    });
  }

  shouldComponentUpdate(props, state) {
    if (props.plan) {
      if (props.plan.reload === true) {
        this.props.history.push("/dashboard");
        return true;
      }
    }
    return true;
  }

  getRow(row, index) {
    return (
      <div key={row.id} className="row">
        <div className="col-4">
          <p className="ass-card-guide">
            {index + 1} .{" "}
            <FormattedMessage
              id="app.dashcard.installment_no"
              defaultMessage="Erä"
            />
          </p>
        </div>
        <div className="col-4">
          <p className="ass-card-guide text-center">
            {moment(row.erapaiva, "YYYY-MM-DD").format("D.M.YYYY")}
          </p>
        </div>
        <div className="col-4">
          <p className="ass-card-guide text-right">{row.summa} €</p>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.redirect === true) {
      return <Redirect to="/dashboard" />;
    }

    if (this.state.toDash === true) {
      return (
        <Redirect
          to={{
            pathname: "/dashboard",
            state: { referrer: "deal" } // this.props.location.state.referrer
          }}
        />
      );
    }

    const debt = this.state.debt;
    const plan = this.props.plan.plan;
    const due = this.props.due;

    if (debt && plan) {
      return (
        <div className="row">
          <div className={"col-sm-12"}>
            <h1 className="header1">
              <FormattedMessage
                id="app.plan.accept_header"
                defaultMessage="Hyväksy osamaksusopimus"
              />
            </h1>
            <ul className="list-unstyled">
              <li className="ass-car-list-element">
                <div className={"card"}>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-8">
                        <h3 className="card-title">{debt.paamies.nimi}</h3>
                        <h6 className="card-subtitle mb-2 ass-card-guide-s">
                          <FormattedMessage
                            id="app.dashcard.case_no"
                            defaultMessage="Asianumero"
                          />: {debt.id}
                        </h6>
                      </div>
                      <div className="col-md-4 text-right" />
                    </div>
                    <hr />
                    <div className="row">
                      <div className={"col-md-6"}>
                        <div className="row">
                          <div className="col-md-12">
                            <p className="ass-card-guide">
                              <FormattedMessage
                                id="app.dashcard.capital"
                                defaultMessage="Avoin pääoma"
                              />
                            </p>
                            <p className="ass-card-price">{debt.avoinna} €</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <p className="ass-card-guide">
                              <FormattedMessage
                                id="app.plan.part_count"
                                defaultMessage="Erien määrä"
                              />
                            </p>
                            <p className="ass-card-price">
                              {
                                Object.keys(plan.maksusopimusera_erittely)
                                  .length
                              }
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <p className="ass-card-guide">
                              <FormattedMessage
                                id="app.plan.interest"
                                defaultMessage="Kulut ja korot"
                              />
                            </p>
                            <p className="ass-card-price">
                              {Number(
                                Math.round(plan.summa - debt.avoinna + "e2") +
                                  "e-2"
                              )}{" "}
                              €
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <p className="ass-card-guide">
                              <FormattedMessage
                                id="app.plan.total"
                                defaultMessage="Maksettava yhteensä"
                              />
                            </p>
                            <p className="ass-card-price">{plan.summa} €</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <p className="ass-card-guide">
                              <FormattedMessage
                                id="app.dashcard.due"
                                defaultMessage="Eräpäivä"
                              />
                            </p>
                            <p className="ass-card-price">
                              <FormattedMessage
                                id="app.plan.due_date_month_day"
                                description="Due day of each month"
                                defaultMessage="Kuukauden {due}. päivä"
                                values={{
                                  due: due.due
                                }}
                              />
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <p className="ass-card-guide">
                              <FormattedMessage
                                id="app.dashcard.first_due"
                                defaultMessage="Ensimmäinen eräpäivä"
                              />
                            </p>
                            <p className="ass-card-price">
                              {plan.maksusopimusera_erittely[0]
                                ? moment(
                                    plan.maksusopimusera_erittely[0].erapaiva,
                                    "YYYY-MM-DD"
                                  ).format("D.M.YYYY")
                                : null}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className={"col-md-6"}>
                        <p className="ass-card-price">
                          <FormattedMessage
                            id="app.plan.plan"
                            defaultMessage="Maksusuunnitelma"
                          />
                        </p>
                        <div className="row">
                          <div className="col-4">
                            <p className="ass-card-price">
                              <FormattedMessage
                                id="app.dashcard.installment_no"
                                defaultMessage="Erä"
                              />
                            </p>
                          </div>
                          <div className="col-4">
                            <p className="ass-card-price text-center">
                              <FormattedMessage
                                id="app.dashcard.due"
                                defaultMessage="Eräpäivä"
                              />
                            </p>
                          </div>
                          <div className="col-4">
                            <p className="ass-card-price text-right">
                              <FormattedMessage
                                id="app.plan.sum"
                                defaultMessage="Summa"
                              />
                            </p>
                          </div>
                        </div>
                        {plan.maksusopimusera_erittely
                          ? plan.maksusopimusera_erittely.map((row, index) =>
                              this.getRow(row, index)
                            )
                          : null}
                        <div className="row">
                          <div className="col-md-12">
                            <hr />
                            <p className="ass-card-price text-right">
                              <FormattedMessage
                                id="app.dashcard.total"
                                defaultMessage="Yhteensä"
                              />{" "}
                              {plan.summa} €
                            </p>
                            <p className={"small text-right"}>
                              <FormattedMessage
                                id="app.dashcard.includes_costs"
                                defaultMessage="Sisältää kulut ja korot"
                              />
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <input
                          type="checkbox"
                          invalid
                          checked={this.state.isChecked}
                          onChange={this.toggleChange}
                        />
                        <p
                          className={"ass-card-guide " + this.state.errorClass}
                        >
                          <a onClick={this.toggle} href={""}>
                            <FormattedMessage
                              id="app.plan.accept"
                              defaultMessage="Hyväksyn osamaksusopimuksen ehdot*"
                            />
                          </a>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <Alert
                          color="secondary"
                          isOpen={this.state.visible}
                          toggle={this.onDismiss}
                        >
                          <FormattedMessage
                            id="error.msg.due_date"
                            defaultMessage="Sinun täytyy hyväksyä osamaksusopimuksen ehdot."
                          />
                        </Alert>
                        <hr />
                        <Button
                          btnText={
                            <FormattedMessage
                              id="button.lbl.accept"
                              defaultMessage="HYVÄKSY"
                            />
                          }
                          btnStyle="primary"
                          btnPath="/dashboard"
                          btnState={this.state.btnState}
                          onClick={this.confirmPlan}
                        />
                        <Button
                          btnText={
                            <FormattedMessage
                              id="button.lbl.cancel"
                              defaultMessage="PERUUTA"
                            />
                          }
                          btnStyle="secondary"
                          btnPath="/dashboard"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div>
            <Modal
              isOpen={this.state.modal}
              toggle={this.toggle}
              className={this.props.className}
            >
              <ModalHeader toggle={this.toggle}>
                <FormattedMessage
                  id="app.plan.conditons"
                  defaultMessage="Maksusuunnitelman ehdot"
                />
              </ModalHeader>
              <ModalBody>
                <p>
                  <FormattedMessage
                    id="app.plan.conditons1"
                    defaultMessage="
                  Maksusuunnitelman laatimisesta aiheutuvat kulut ovat 20, 30 tai 50 euroa riippuen velan pääoman suuruudesta ja erien määrästä."
                  />
                </p>
                <p>
                  <FormattedMessage
                    id="app.plan.conditons2"
                    defaultMessage="Maksusuunnitelman erät on maksettava sovittuina eräpäivinä. Mikäli sovittuja maksueriä ja eräpäiviä ei noudateta, maksusuunnitelma purkautuu ja jäljellä olevan velan perintä jatkuu."
                  />
                </p>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={this.toggle}
                  btnText={
                    <FormattedMessage
                      id="button.lbl.close"
                      defaultMessage="SULJE"
                    />
                  }
                />
              </ModalFooter>
            </Modal>
          </div>
        </div>
      );
    } else {
      return "Loading...";
    }
  }
}

const mapStateToProps = function(store) {
  return {
    debts: store.debts.debts,
    plan: store.plan,
    due: store.due
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchPlan: (id, parts, due) => dispatch(fetchPlan(id, parts, due)),
    createPlan: (id, parts, due) => dispatch(createPlan(id, parts, due))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanDeal);



// WEBPACK FOOTER //
// ./src/containers/PaymentPlan/PlanDeal.js